module.exports = __webpack_public_path__ + "img/obj.695389b3.png";